/** Presentation helpers. Anything that turns raw API data into printed text. */

const DATE_PARTS = new Intl.DateTimeFormat("en-US", {
  weekday: "short",
  month: "short",
  day: "numeric",
  timeZone: "America/Los_Angeles",
});

const TIME_PARTS = new Intl.DateTimeFormat("en-US", {
  hour: "numeric",
  minute: "2-digit",
  timeZone: "America/Los_Angeles",
});

export function formatEventDate(iso: string): { month: string; day: string; weekday: string } {
  const parts = DATE_PARTS.formatToParts(new Date(iso));
  const find = (type: Intl.DateTimeFormatPartTypes) =>
    parts.find((part) => part.type === type)?.value ?? "";

  return { month: find("month"), day: find("day"), weekday: find("weekday") };
}

export function formatEventTime(iso: string): string {
  return TIME_PARTS.format(new Date(iso));
}

/** A stat cell: two decimals, or an em dash when the number is unknown. */
export function formatStat(value: number | null, decimals = 2): string {
  return value == null ? "—" : value.toFixed(decimals);
}

export function formatInteger(value: number | null): string {
  return value == null ? "—" : Math.round(value).toLocaleString("en-US");
}

/** "12 minutes ago" style freshness, kept deliberately coarse. */
export function formatAge(seconds: number): string {
  if (seconds < 90) return "just now";
  const minutes = Math.round(seconds / 60);
  if (minutes < 60) return `${minutes} min ago`;
  const hours = Math.round(minutes / 60);
  if (hours < 24) return `${hours} hr ago`;
  const days = Math.round(hours / 24);
  return `${days} ${days === 1 ? "day" : "days"} ago`;
}
